import _ from 'lodash'
import moment from 'moment'
import { fetchAllTrackers } from './queries'
import { fetchTracker } from '../tracker-detail/queries'
import TrackedGeolocation from '../../models/tracked-geolocation'
import GeolocationTracker from '../../models/geolocation-tracker'
import { objectKeysToCamelCase } from '../../common/case-style-conversion'

export const findAllTrackers = async () => {
  const trackers = []
  let offset = 0
  const limit = 50

  // We will fetch the data paginated because of performance reasons
  // even though we have to wait for all the data to be shown in the map
  let newTrackers = await fetchAllTrackers(offset, limit)
  trackers.push(...newTrackers)
  while (!_.isEmpty(newTrackers)) {
    offset += limit
    newTrackers = await fetchAllTrackers(offset, limit)
    trackers.push(...newTrackers)
  }

  return sortByLastUpdate(GeolocationTracker.many(trackers.map(objectKeysToCamelCase)))
}

function sortByLastUpdate(trackers) {
  return _.sortBy(trackers, tracker => {
    if (moment(tracker.lastUpdate).isValid()) return tracker.lastUpdate
    return ' '
  }).reverse()
}

export const getLocations = async trackerId => {
  const trackerInfo = await fetchTracker(trackerId)
  return TrackedGeolocation.many(trackerInfo.locations)
}
